export const TKeyExtension = {
  EXTENSION_FEATURE_CALLS_TITLE: "EXTENSION_FEATURE_CALLS_TITLE",
  EXTENSION_FEATURE_CALLS_DESC: "EXTENSION_FEATURE_CALLS_DESC",
  EXTENSION_FEATURE_EXTRACT_TITLE: "EXTENSION_FEATURE_EXTRACT_TITLE",
  EXTENSION_FEATURE_EXTRACT_DESC: "EXTENSION_FEATURE_EXTRACT_DESC",
  EXTENSION_FEATURE_PROSPECTS_TITLE: "EXTENSION_FEATURE_PROSPECTS_TITLE",
  EXTENSION_FEATURE_PROSPECTS_DESC: "EXTENSION_FEATURE_PROSPECTS_DESC",
} as const;
